import React from 'react';
import { UsersQueryProvider } from './UsersQueryProvider';
import { UsersCacheProvider } from './UsersCacheContext';

export const UsersProviders = ({ children }: any) => {
	return (
		<UsersCacheProvider>
			<UsersQueryProvider>{children}</UsersQueryProvider>
		</UsersCacheProvider>
	);
};
